"use client";
import {
  createStoreContext
} from "./VOQWLFSQ.js";

// src/checkbox/checkbox-context.tsx
var ctx = createStoreContext();
var useCheckboxContext = ctx.useContext;
var useCheckboxScopedContext = ctx.useScopedContext;
var useCheckboxProviderContext = ctx.useProviderContext;
var CheckboxContextProvider = ctx.ContextProvider;
var CheckboxScopedContextProvider = ctx.ScopedContextProvider;

export {
  useCheckboxContext,
  useCheckboxScopedContext,
  useCheckboxProviderContext,
  CheckboxContextProvider,
  CheckboxScopedContextProvider
};
